import { createFromIconfontCN } from '@ant-design/icons';

export default createFromIconfontCN({
    scriptUrl: "/iconfont/font_4749113_x6903hb3t8g.js"
})